import Validator from "./Validator";

export default class JsonEntitiesEntityDataSubTitleValidator extends Validator {
  constructor() {
    super();
    this.validationRules = {
      type: 'string',
      empty: false,
      mandatory: false
    };
  }
}
